export const PROJECT_MASTER_DATA_FIELDS = [
  {
    key: 'products',
    label: 'Products In Scope',
    description: 'Product options shown when partners select products for a project.',
    addPlaceholder: 'e.g. TrueSight Server Automation (TSSA)',
  },
  {
    key: 'engagementTypes',
    label: 'Engagement Types',
    description: 'Engagement type options on the submit and edit project forms.',
    addPlaceholder: 'e.g. New Implementation',
  },
  {
    key: 'deploymentModels',
    label: 'Deployment Models',
    description: 'Deployment model options such as SaaS, On-Premise, or Hybrid.',
    addPlaceholder: 'e.g. SaaS',
  },
  {
    key: 'competitiveContexts',
    label: 'Competitive Context',
    description: 'Competitive context options for project submissions.',
    addPlaceholder: 'e.g. Greenfield',
  },
  {
    key: 'projectStatus',
    label: 'Project Status',
    description: 'Project status values available to staff in project detail screens.',
    addPlaceholder: 'e.g. Sales Cycle / Lost',
  },
  {
    key: 'tierType',
    label: 'Tier Type',
    description: 'Tier type options used on partner company records.',
    addPlaceholder: 'e.g. Elite',
  },
  {
    key: 'serviceLevel',
    label: 'Service Level',
    description: 'Service level options used on partner company records.',
    addPlaceholder: 'e.g. Gold',
  },
];

export const EMPTY_PROJECT_MASTER_DATA = {
  products: [],
  engagementTypes: [],
  deploymentModels: [],
  competitiveContexts: [],
  projectStatus: [],
  tierType: [],
  serviceLevel: [],
};

export const getProjectMasterDataField = (fieldKey) => (
  PROJECT_MASTER_DATA_FIELDS.find((field) => field.key === fieldKey) || null
);
